import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 21.554 32.332",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21.554 32.332\" id=\"icon-chevron-right\"><path d=\"M9.553,32.332,4,26.943,14.777,16.166,4,5.389,9.553,0l16,16.166Z\" transform=\"translate(-4)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol